import { Stack, Typography } from '@mui/material'
import { ForceErrorButton } from '~/errors/ForceErrorButton'
import { type ReactNode } from 'react'

export function PageHeader({ title, actions }: { title: string; actions?: ReactNode }) {
  // space-between (not ml:auto on the child): MUI Stack spacing margins override a
  // child's own ml — live-verify catch on the V7 Reset-button placement.
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{ mb: 3 }}
    >
      <Typography variant="h4">{title}</Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <ForceErrorButton />
        {actions}
      </Stack>
    </Stack>
  )
}
